import React from "react";
import { CheckCircle } from "@phosphor-icons/react";

const Hero: React.FC = () => {
  return (
    <div className="rounded-xl border border-gray-200 dark:border-neutral-700 bg-white dark:bg-neutral-800 p-4 shadow-sm">
      <h1 className="text-3xl md:text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">
        Store Integration Hub: Connect Your Revenue Sources
      </h1>
      <h3 className="mt-4 text-xl font-semibold text-gray-900 dark:text-white">
        Welcome to the AppRevBooster Integration Hub!
      </h3>
      <p className="mt-3 text-base leading-relaxed text-gray-600 dark:text-gray-300 max-w-4xl">
        Connect your primary app stores—where users make their in-app
        purchases (IAP) and subscriptions—directly to your AppRevBooster account. By integrating your stores,
        you enable AppRevBooster to securely and automatically:
      </p>
      <div className="mt-6 grid grid-cols-1">
        <div className="flex items-start gap-3">
          <CheckCircle className="text-green-600 shrink-0 mt-0.5" size={20} />
          <p className="text-base leading-relaxed text-gray-700 dark:text-gray-200">
            <span className="font-medium">Unify Data:</span> Consolidate purchases, subscriptions, and revenue from Google Play and Apple App Store into a single dashboard.
          </p>
        </div>
        <div className="flex items-start gap-3">
          <CheckCircle className="text-green-600 shrink-0 mt-0.5" size={20} />
          <p className="text-base leading-relaxed text-gray-700 dark:text-gray-200">
            <span className="font-medium">Real-Time Analytics:</span> Access accurate, up-to-the-minute data to measure performance.
          </p>
        </div>
        <div className="flex items-start gap-3">
          <CheckCircle className="text-green-600 shrink-0 mt-0.5" size={20} />
          <p className="text-base leading-relaxed text-gray-700 dark:text-gray-200">
            <span className="font-medium">Optimize Monetization:</span> Link revenue to acquisition and ads for comprehensive ROI analysis.
          </p>
        </div>
      </div>
      <p className="mt-6 text-sm text-gray-600 dark:text-gray-300">
        Need help? Review the specific guide for troubleshooting. If the problem persists, write to us at{" "}
        <a className="text-indigo-600 hover:underline" href="mailto:support@apprevbooster.com">support@apprevbooster.com</a>.
      </p>
    </div>
  );
};

export default Hero;
